import React, {useEffect, useState} from 'react';
import {apiUrl} from "../../../libs/api";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShare} from "@fortawesome/free-solid-svg-icons";
import {SelectField} from "../FormField";
import _ from "lodash";

const typeMessagesInit = {
    loading : true,
    data : [],
    init : false
}

export const ListTypeMessages = ({
    onSelect =  (text)=>{}
                                 }) => {
    const [typeMessages, setTypeMessages] = useState(typeMessagesInit);
    const [currentOption, setCurrentOptions] = useState("");
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await apiUrl.get(`/warnings/list-type-messages`);
                setTypeMessages({
                    loading: false,
                    data : result || [],
                    init: true
                })
            }
            catch (e){
                setTypeMessages({
                    loading: false,
                    data : [],
                    init: true
                })
            }
        }
        fetchData();
    }, []);


    function _onSelect() {
        let selectOption = typeMessages.data.find(item => item._id === currentOption);
        if(_.get(selectOption, 'message')){
            onSelect(selectOption.message);
        }
    }

    return (
        <div id="list-type-messages">
            <div className={"options-messages"}>
                <SelectField name={"type-message"} value={currentOption}
                             onChange={(event) => setCurrentOptions(event.target.value)}>
                    <option value="">Aucun</option>
                    {typeMessages.data.map((item) => <option value={item._id} key={item._id}>{item.title}</option>)}
                </SelectField>
            </div>
            <div className={"cta-copy"} onClick={()=> _onSelect()}>
                <FontAwesomeIcon icon={faShare}/>
                Insérer
            </div>
        </div>
    )


};
export default ListTypeMessages;